const ENV = process.env.VARNISH_ENV
const NODE_ENV = process.env.NODE_ENV
const [GOLD, SHOPIFY] = ['gold', 'shopify']

const isDevelopment = () => {
  return NODE_ENV && (NODE_ENV === 'development')
}

const isProduction = () => {
  return NODE_ENV && (NODE_ENV === 'production')
}

const isStaging = () => {
  return NODE_ENV && (NODE_ENV === 'staging')
}

const isGoldEnv = () => {
  return ENV === GOLD
}

const isShopifyEnv = () => {
  return ENV === SHOPIFY
}

export {
  ENV,
  GOLD,
  SHOPIFY,
  isGoldEnv,
  isShopifyEnv,
  isDevelopment,
  isProduction,
  isStaging
}



// WEBPACK FOOTER //
// ./uncommon-client/utilities/environment.js